//==本JS是加载Lodop插件及CLodop服务的综合示例，可直接使用，建议看懂后融进自己页面程序==

var CreatedOKLodopObject, CLodopIsLocal, CLodopJsState;


//==判断是否需要CLodop(那些不支持插件的浏览器):==
function needCLodop() {
    try {
        var ua = navigator.userAgent;
        if (ua.match(/Windows\sPhone/i))
            return true;
        if (ua.match(/iPhone|iPod|iPad/i))
            return true;
        if (ua.match(/Android/i))
            return true;
        if (ua.match(/Edge\D?\d+/i))
            return true;

        var verTrident = ua.match(/Trident\D?\d+/i);
        var verIE = ua.match(/MSIE\D?\d+/i);
        var verOPR = ua.match(/OPR\D?\d+/i);
        var verFF = ua.match(/Firefox\D?\d+/i);
        var x64 = ua.match(/x64/i);
        if ((!verTrident) && (!verIE) && (x64))
            return true;
        else if (verFF) {
            verFF = verFF[0].match(/\d+/);
            if ((verFF[0] >= 41) || (x64))
                return true;
        } else if (verOPR) {
            verOPR = verOPR[0].match(/\d+/);
            if (verOPR[0] >= 32)
                return true;
        } else if ((!verTrident) && (!verIE)) {
            var verChrome = ua.match(/Chrome\D?\d+/i);
            if (verChrome) {
                verChrome = verChrome[0].match(/\d+/);
                if (verChrome[0] >= 41)
                    return true;
            }
        }
        return true;
    } catch (err) {
        return true;
    }
}

//==引用CLodop的主JS,用双端口8000和18000(以防其中一个被占):==
if (needCLodop()) {
	var userinfo = localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem("userInfo")) : "";
	if(userinfo && userinfo.supplierTransport != 2){
	    var head = document.head || document.getElementsByTagName("head")[0] || document.documentElement;
	    
	    var JS1 = document.createElement("script");
	    var JS2 = document.createElement("script");
	    
	    var protocol = window.location.protocol;//http、https
	    var src1,src2;
	    if(protocol == 'https:'){
	        src1 = "https://localhost:8443/CLodopfuncs.js?priority=1";
	        src2 = "https://localhost:8444/CLodopfuncs.js?priority=0";
	    }else{
	        src1 = "http://localhost:8000/CLodopfuncs.js?priority=1";
	        src2 = "http://localhost:18000/CLodopfuncs.js?priority=0";
	    }
	    
	    
	    JS1.src = src1;
	    JS2.src = src2;
	    
	    head.insertBefore(JS1, head.firstChild);
	    head.insertBefore(JS2, head.firstChild);
	
	    CLodopIsLocal = !!((JS1.src + JS2.src).match(/\/\/localho|\/\/127.0.0./i));
	
	    if (JS1.attachEvent) {
	    	CLodopJsState = "loading";
	        var onChange = function(){ 
		     if (window.event.srcElement.readyState == 'loaded')               
		     CLodopJsState = "complete";
		};
		JS1.attachEvent('onreadystatechange',onChange);
		JS2.attachEvent('onreadystatechange',onChange);
	    }
    }
}

//==获取LODOP对象主过程,判断是否安装、需否升级:==
function getLodop(oOBJECT, oEMBED) {
//	var strHtmInstall = [
//      '<div class="alert alert-warning lodop-alert" role="alert" style="z-index:9999;">',
//			'<strong class="d-block d-sm-inline-block-force wzd-txt">',
//				'打印控件未安装!点击这里<a href="install_lodop32.rar" target="_self">执行安装</a>,安装后请刷新页面或重新进入。',
//			'</strong>',
//		'</div>'
//      ].join('');
//  var strHtmUpdate = [
//      '<div class="alert alert-warning lodop-alert" role="alert" style="z-index:9999;">',
//			'<strong class="d-block d-sm-inline-block-force wzd-txt">',
//				'打印控件需要升级!点击这里<a href="install_lodop32.rar" target="_self">执行升级</a>,升级后请重新进入。',
//			'</strong>',
//		'</div>'
//      ].join('');
//  var strHtm64_Install = [
//      '<div class="alert alert-warning lodop-alert" role="alert" style="z-index:9999;">',
//			'<strong class="d-block d-sm-inline-block-force wzd-txt">',
//				'打印控件未安装!点击这里<a href="install_lodop64.rar" target="_self">执行安装</a>,安装后请刷新页面或重新进入。',
//			'</strong>',
//		'</div>'
//      ].join('');
//  var strHtm64_Update = [
//      '<div class="alert alert-warning lodop-alert" role="alert" style="z-index:9999;">',
//			'<strong class="d-block d-sm-inline-block-force wzd-txt">',
//				'打印控件需要升级!点击这里<a href="install_lodop64.rar" target="_self">执行升级</a>,升级后请重新进入。',
//			'</strong>',
//		'</div>'
//      ].join('');
//  var strHtmFireFox = [
//      '<div class="alert alert-warning lodop-alert" role="alert" style="z-index:9999;">',
//			'<strong class="d-block d-sm-inline-block-force wzd-txt">',
//				'（注意：如曾安装过Lodop旧版附件npActiveXPLugin,请在【工具】->【附加组件】->【扩展】中先卸它）。',
//			'</strong>',
//		'</div>'
//      ].join('');
//  var strHtmChrome = [
//      '<div class="alert alert-warning lodop-alert" role="alert" style="z-index:9999;">',
//			'<strong class="d-block d-sm-inline-block-force wzd-txt">',
//				'(如果此前正常，仅因浏览器升级或重安装而出问题，需重新执行以上安装）。',
//			'</strong>',
//		'</div>'
//      ].join('');
//  var strCLodopInstall_1 = [
//      '<div class="alert alert-warning lodop-alert" role="alert" style="z-index:9999;">',
//			'<strong class="d-block d-sm-inline-block-force wzd-txt">',
//				'Web打印服务CLodop未安装启动，点击这里<a href="CLodop_Setup_for_Win32NT.rar" target="_self">下载执行安装</a>，（若此前已安装过，可<a href="CLodop.protocol:setup" target="_self">点这里直接再次启动</a>），成功后请刷新本页面。',
//			'</strong>',
//		'</div>'
//      ].join('');    
//  var strCLodopInstall_2 = [
//      '<div class="alert alert-warning lodop-alert" role="alert" style="z-index:9999;">',
//			'<strong class="d-block d-sm-inline-block-force wzd-txt">',
//				'（若此前已安装过，可<a href="CLodop.protocol:setup" target="_self">点这里直接再次启动</a>），成功后请刷新本页面。',
//			'</strong>',
//		'</div>'
//      ].join('');     
//  var strCLodopInstall_3 = [
//      '<div class="alert alert-warning lodop-alert" role="alert" style="z-index:9999;">',
//			'<strong class="d-block d-sm-inline-block-force wzd-txt">',
//				'，成功后请刷新本页面。',
//			'</strong>',
//		'</div>'
//      ].join('');   
//  var strCLodopUpdate = [
//      '<div class="alert alert-warning lodop-alert" role="alert" style="z-index:9999;">',
//			'<strong class="d-block d-sm-inline-block-force wzd-txt">',
//				'Web打印服务CLodop需升级!点击这里<a href="CLodop_Setup_for_Win32NT.rar" target="_self">执行升级</a>,升级后请刷新页面。。',
//			'</strong>',
//		'</div>'
//      ].join('');       
    document.getElementById("lodopAlertTxt").innerHTML = "";
    var strHtmInstall = "<font color='#c47709'>打印控件未安装!点击这里<a href='install_lodop32.rar' target='_self'>执行安装</a>,安装后请<a href='javascript:location.reload();'>刷新页面</a>或重新进入。</font>";
    var strHtmUpdate = "<font color='#c47709'>打印控件需要升级!点击这里<a href='install_lodop32.rar' target='_self'>执行升级</a>,升级后请重新进入。</font>";
    var strHtm64_Install = "<font color='#c47709'>打印控件未安装!点击这里<a href='install_lodop64.rar' target='_self'>执行安装</a>,安装后请<a href='javascript:location.reload();'>刷新页面</a>或重新进入。</font>";
    var strHtm64_Update = "<font color='#c47709'>打印控件需要升级!点击这里<a href='install_lodop64.rar' target='_self'>执行升级</a>,升级后请重新进入。</font>";
    var strHtmFireFox = "<font color='#c47709'>（注意：如曾安装过Lodop旧版附件npActiveXPLugin,请在【工具】->【附加组件】->【扩展】中先卸它）</font>";
    var strHtmChrome = "<font color='#c47709'>(如果此前正常，仅因浏览器升级或重安装而出问题，需重新执行以上安装）</font>";
    var strCLodopInstall_1 = "<font color='#c47709'>Web打印服务CLodop未安装启动，点击这里<a href='CLodop_Setup_for_Win32NT.rar' target='_self'>下载执行安装</a>";
    var strCLodopInstall_2 = "（若此前已安装过，可<a href='CLodop.protocol:setup' target='_self'>点这里直接再次启动</a>）";
    var strCLodopInstall_3 = "，成功后请<a href='javascript:location.reload();'>刷新页面</a>。</font>";
    var strCLodopInstall_4 = "火狐 https 需要自己添加https://localhost:8443到例外"
    var strCLodopUpdate = "<font color='#c47709'>Web打印服务CLodop需升级!点击这里<a href='CLodop_Setup_for_Win32NT.rar' target='_self'>执行升级</a>,升级后请<a href='javascript:location.reload();'>刷新页面</a>。</font>";
    var LODOP;
    try {
        var ua = navigator.userAgent;
        var isIE = !!(ua.match(/MSIE/i)) || !!(ua.match(/Trident/i));
        if (needCLodop()) {
            try {
                LODOP = getCLodop();
            } catch (err) {}
            if (!LODOP && (document.readyState !== "complete" || (isIE  && CLodopJsState == "loading")) ) {
                alert("网页还没下载完毕，请稍等一下再操作.");
                return;
            }
            if (!LODOP) {
//          	document.getElementById("lodopAlertTxt").innerHTML = strCLodopInstall_1 + document.getElementById("lodopAlertTxt").innerHTML;   
				$(".lodop-alert").css({"opacity":1,"z-index":9999})
				if(ua.indexOf('Firefox') >= 0){
					document.getElementById("lodopAlertTxt").innerHTML = strCLodopInstall_1 + (CLodopIsLocal ? strCLodopInstall_2 : "") + strCLodopInstall_3 + strCLodopInstall_4 + document.getElementById("lodopAlertTxt").innerHTML;                
				}else{
					document.getElementById("lodopAlertTxt").innerHTML = strCLodopInstall_1 + (CLodopIsLocal ? strCLodopInstall_2 : "") + strCLodopInstall_3 + document.getElementById("lodopAlertTxt").innerHTML;                
				}
                return;
            } else {
                if (CLODOP.CVERSION < "4.0.8.8") {
                	$(".lodop-alert").css({"opacity":1,"z-index":9999})
                    document.getElementById("lodopAlertTxt").innerHTML = strCLodopUpdate + document.getElementById("lodopAlertTxt").innerHTML;
                }
                if (oEMBED && oEMBED.parentNode)
                    oEMBED.parentNode.removeChild(oEMBED);
                if (oOBJECT && oOBJECT.parentNode)
                    oOBJECT.parentNode.removeChild(oOBJECT);
            }
        } else {
            var is64IE = isIE && !!(ua.match(/x64/i));
            //==如果页面有Lodop就直接使用,否则新建:==
            if (oOBJECT || oEMBED) {
                if (isIE)
                    LODOP = oOBJECT;
                else
                    LODOP = oEMBED;
            } else if (!CreatedOKLodopObject) {
                LODOP = document.createElement("object");
                LODOP.setAttribute("width", 0);
                LODOP.setAttribute("height", 0);
                LODOP.setAttribute("style", "position:absolute;left:0px;top:-100px;width:0px;height:0px;");
                if (isIE)
                    LODOP.setAttribute("classid", "clsid:2105C259-1E0C-4534-8141-A753534CB4CA");
                else
                    LODOP.setAttribute("type", "application/x-print-lodop");
                document.documentElement.appendChild(LODOP);
                CreatedOKLodopObject = LODOP;
            } else
                LODOP = CreatedOKLodopObject;
            //==Lodop插件未安装时提示下载地址:==
            if ((!LODOP) || (!LODOP.VERSION)) {
                if (ua.indexOf('Chrome') >= 0)
                $(".lodop-alert").css({"opacity":1,"z-index":9999})
                    document.getElementById("lodopAlertTxt").innerHTML = strHtmChrome + document.getElementById("lodopAlertTxt").innerHTML;
                if (ua.indexOf('Firefox') >= 0)
                $(".lodop-alert").css({"opacity":1,"z-index":9999})
                    document.getElementById("lodopAlertTxt").innerHTML = strHtmFireFox + document.getElementById("lodopAlertTxt").innerHTML;
               		document.getElementById("lodopAlertTxt").innerHTML = (is64IE ? strHtm64_Install : strHtmInstall) + document.getElementById("lodopAlertTxt").innerHTML;
                return LODOP;
            }
        }
        if (LODOP.VERSION < "6.2.2.6") {
            if (!needCLodop())
            $(".lodop-alert").css({"opacity":1,"z-index":9999})
            document.getElementById("lodopAlertTxt").innerHTML = (is64IE ? strHtm64_Update : strHtmUpdate) + document.getElementById("lodopAlertTxt").innerHTML;
        }
        //===如下空白位置适合调用统一功能(如注册语句、语言选择等):==

		LODOP.SET_LICENSES("上海胤元电子科技公司","30970454764A901399A829227BE295B6AE2","上海胤元電子科技公司","53C757EDDC0F30400A49226DB985C89FC5B");
		LODOP.SET_LICENSES("THIRD LICENSE","","Shanghai Yinyuan Electronic Technology Co., Ltd","9D0E8CC42A1618E63653667F89849F63701");

        //=======================================================
        
        return LODOP;
    } catch (err) {
        alert("getLodop出错:" + err);
    }
}
export { getLodop };